<template>
  <div class="pa-4">
    <v-app-bar flat color="transparent" class="mb-2">
      <!-- MELHORIA: esta tela agora também é aberta a partir do botão "+" de Emissão de Nota
      (IssuanceInvoiceView.vue) e da ação "Editar"/"Duplicar" da mesma grade — "voltar" usa o
      histórico do navegador em vez de sempre forçar "/notaAvulsa", assim retorna pra tela de
      onde o usuário realmente veio (Emissão de Nota ou a listagem de Notas Sem JOB). -->
      <v-btn icon @click="$router.go(-1)">
        <v-icon color="primary">mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="title">
        <!-- MELHORIA: renomeado de "Avulsa" para "Sem JOB" (nomenclatura pedida pelo usuário; a
        rota/nome interno do componente continuam os mesmos, só o texto exibido mudou). Título
        também reflete o modo edição/duplicação. -->
        {{ tituloTela }}
      </v-toolbar-title>
      <v-spacer />
      <v-btn text color="secondary" class="mr-2" :loading="carregandoPreview" :disabled="!notaSalva" @click="preVisualizar">
        <v-icon left small>mdi-eye</v-icon> Pré-Visualização
      </v-btn>
      <v-btn color="primary" :loading="salvando" @click="salvarNota">
        <v-icon left small>mdi-content-save</v-icon> Salvar
      </v-btn>
    </v-app-bar>

    <v-alert type="info" outlined dense class="mb-4">
      Nota Fiscal Sem JOB — esta nota <b>não</b> é vinculada a nenhum Job/Ordem de Serviço. Após salvar, use
      "Pré-Visualização" para conferir a DANFe antes de decidir emitir de verdade (a emissão real é uma ação
      separada, feita na tela de listagem "Emissão de Nota").
    </v-alert>

    <v-card class="mb-4" outlined>
      <v-card-title>Destinatário</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="5">
            <v-autocomplete
              v-model="destinatarioSelecionado"
              :items="destinatarios"
              :item-text="itemTextDestinatario"
              item-value="id"
              :label="isNfRemessa ? 'Fornecedor (destinatário da remessa)' : 'Cliente'"
              outlined dense clearable return-object
              :loading="carregandoDestinatarios"
              :search-input.sync="buscaDestinatario"
              @change="selecionarDestinatario"
              no-filter
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title>Digite para buscar {{ isNfRemessa ? 'um fornecedor' : 'um cliente' }}...</v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="objNf.cnpj" label="CNPJ" outlined dense />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field v-model="objNf.email" label="Email" outlined dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="objNf.cep" label="CEP" outlined dense />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field v-model="objNf.logradouro" label="Logradouro" outlined dense />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field v-model="objNf.numero" label="Número" outlined dense />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="objNf.bairro" label="Bairro" outlined dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field v-model="objNf.cidade" label="Cidade" outlined dense />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="objNf.codigoCidade" label="Código IBGE da Cidade" outlined dense />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field v-model="objNf.uf" label="UF" outlined dense />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" outlined>
      <v-card-title>Dados Fiscais da Nota</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              v-model="objNf.cfop"
              :items="cfops"
              item-text="codigo"
              item-value="codigo"
              label="CFOP"
              outlined dense
              @change="selecionarCfop"
            >
              <template v-slot:item="{ item }">
                <div class="d-flex flex-column">
                  <div class="font-weight-bold">{{ item.codigo }}</div>
                  <div>{{ item.descricao }}</div>
                </div>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="5">
            <v-text-field v-model="objNf.naturezaOp" label="Natureza de Operação" outlined dense readonly />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-combobox v-model="objNf.condPag" :items="['á vista', 'á prazo']" label="Condição de Pagamento" outlined dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-combobox v-model="objNf.meioPagamento" :items="meioPagamentoOptions" label="Meio de Pagamento" outlined dense />
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="isNfRemessa">
            <v-text-field v-model="objNf.codigoBeneficioFiscal" label="Código Benefício Fiscal" outlined dense />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" outlined>
      <v-card-title>
        Itens da Nota
        <v-spacer />
        <v-btn color="primary" small @click="abrirBuscaItem">
          <v-icon left small>mdi-plus</v-icon> Adicionar Item
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-alert v-if="itens.length === 0" type="warning" outlined dense>
          Nenhum item adicionado ainda.
        </v-alert>
        <v-simple-table v-else dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th class="text-right">Qtd</th>
                <th class="text-right">Valor Unit.</th>
                <th class="text-right">Valor Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in itens" :key="index">
                <td>{{ item.codigo || item.itemCodigo }}</td>
                <td>{{ item.descricao }}</td>
                <td class="text-right">{{ item.quantidade }}</td>
                <td class="text-right">{{ formatMoeda(parseValorUnitarioItem(item.valorUnitario)) }}</td>
                <td class="text-right">{{ formatMoeda(item.valorTotal / 100) }}</td>
                <td>
                  <v-btn icon x-small @click="editarItem(index)"><v-icon small color="warning">mdi-pencil</v-icon></v-btn>
                  <v-btn icon x-small @click="removerItem(index)"><v-icon small color="red">mdi-delete</v-icon></v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div class="text-right mt-2 font-weight-bold" v-if="itens.length">
          Total da Nota: {{ formatMoeda(totalItens) }}
        </div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" outlined>
      <v-card-title>Transporte (opcional)</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              v-model="objNf.transportadora"
              :items="transportadoras"
              item-text="razaoSocial"
              item-value="id"
              label="Transportadora"
              outlined dense clearable
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field v-model="objNf.pesoBruto" label="Peso Bruto (KG)" outlined dense />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field v-model="objNf.pesoLiquido" label="Peso Líquido (KG)" outlined dense />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" outlined>
      <v-card-title>Informações Adicionais</v-card-title>
      <v-card-text>
        <v-textarea v-model="objNf.informacaoAdd" outlined label="Informações Adicionais" />
      </v-card-text>
    </v-card>

    <!-- Dialog: buscar item (StockBalance) para adicionar -->
    <v-dialog v-model="dialogBuscaItem" max-width="700px">
      <v-card>
        <v-card-title>Buscar Item (Saldo de Estoque)</v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="stockBalanceSelecionado"
            :items="stockBalanceOpcoes"
            :item-text="(i) => `${i.itemCodigo} - ${i.itemDescricao}`"
            item-value="id"
            label="Buscar por código ou descrição"
            outlined dense return-object
            :loading="carregandoStockBalance"
            :search-input.sync="buscaStockBalance"
            no-filter
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>Digite ao menos 2 caracteres para buscar...</v-list-item-title>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogBuscaItem = false">Cancelar</v-btn>
          <v-btn color="primary" :disabled="!stockBalanceSelecionado" @click="confirmarItemSelecionado">Avançar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CreateItensNotaFiscalView
      :open="openItemEdit"
      :itemEdit="itemEmEdicao"
      :itemsByRomaneio="[]"
      :jobSelected="{}"
      :isNfRemessa="isNfRemessa"
      :isNfReferenciada="false"
      :isDuplicating="false"
      @save="handleSaveItem"
      @cancel="handleCancelItem"
    />

    <PrevieNotaFiscalView
      :open="dialogPreview"
      :notasFiscalPreVisualizacao="pdfPreviewBase64"
      @back="dialogPreview = false"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import EntityService from '../../services/entityService';
import NotaFiscalAvulsaPlugNotasService from '../../api/v2/services/NotaFiscalAvulsaPlugNotasService';
import CreateItensNotaFiscalView from '../IssuanceInvoice/formCreateNF/CreateItensNotaFiscalView.vue';
import PrevieNotaFiscalView from '../IssuanceInvoice/PrevieNotaFiscalView.vue';

export default {
  name: 'CriarNotaAvulsaView',
  components: { CreateItensNotaFiscalView, PrevieNotaFiscalView },
  data() {
    return {
      fisPreDocEmi: new EntityService('FisPreDocEmi'),
      emissaoDoc: new EntityService('EmissaoNotasFiscais'),
      itemEntity: new EntityService('FisPreDocEmiItem'),
      salvando: false,
      carregandoPreview: false,
      notaSalva: null, // guarda { fisPreDocEmiId, emissaoDocId } depois de salvar
      destinatarios: [],
      destinatarioSelecionado: null,
      buscaDestinatario: '',
      carregandoDestinatarios: false,
      // BUGFIX (hardening achado no teste desta tela): buscaDestinatario dispara uma requisição a
      // cada tecla digitada (search-input.sync, sem debounce), sem nenhuma proteção contra a
      // resposta de uma busca antiga chegar DEPOIS da resposta de uma busca mais recente e
      // sobrescrever "destinatarios" com resultados que não correspondem ao texto atualmente
      // digitado (o autocomplete usa no-filter, então a lista clicável passa a refletir
      // exatamente o que está em "destinatarios"). Um contador de sequência garante que só a
      // resposta da ÚLTIMA busca disparada é aplicada. NOTA: investigando um caso concreto onde o
      // nome gravado divergia do cliente selecionado, a causa real acabou sendo outra (ver
      // relatório do teste) — o backend recalcula "destinatarioNome"/"destinatarioFornecedorNome"
      // a partir da razão social do cadastro ao salvar EmissaoNotasFiscais, então o valor
      // persistido nem sempre bate com o "nomeFantasia" mostrado no autocomplete; isso é
      // comportamento do backend, não bug de tela. Este guard continua válido por si só (corrige
      // uma classe real de race condition), só não foi a causa daquele caso específico.
      buscaDestinatarioSeq: 0,
      buscaStockBalanceSeq: 0,
      cfops: [],
      transportadoras: [],
      itens: [],
      dialogBuscaItem: false,
      stockBalanceOpcoes: [],
      stockBalanceSelecionado: null,
      buscaStockBalance: '',
      carregandoStockBalance: false,
      openItemEdit: false,
      itemEmEdicao: {},
      itemEmEdicaoIndex: -1,
      dialogPreview: false,
      pdfPreviewBase64: '',
      // MELHORIA: suporte a edição/duplicação de uma nota Sem JOB já existente, acessada a partir
      // do menu de ações (⋮) da grade de Emissão de Nota (IssuanceInvoiceView.vue::editValue/
      // duplicateValue), que navega para esta mesma tela passando ?id=<FisPreDocEmi>&emissaoId=
      // <EmissaoNotasFiscais>[&duplicate=1].
      carregandoNotaExistente: false,
      modoEdicao: false,
      modoDuplicacao: false,
      meioPagamentoOptions: [
        'Dinheiro', 'Cheque', 'Cartão de Crédito', 'Cartão de Débito', 'Cartão da Loja',
        'Vale Alimentação', 'Vale Refeição', 'Vale Presente', 'Vale Combustível',
        'Boleto Bancário', 'Depósito Bancário', 'Pagamento Instantâneo (PIX) - Dinâmico',
        'Transferência bancária, Carteira Digital', 'Sem pagamento', 'Pagamento Posterior', 'Outros'
      ],
      objNf: {
        cnpj: '', email: '', cep: '', cidade: '', codigoCidade: '', logradouro: '',
        bairro: '', numero: '', complemento: '', uf: '', condPag: 'á vista', meioPagamento: '',
        cfop: null, naturezaOp: '', operacaoFiscal: '', transportadora: '', pesoBruto: '',
        pesoLiquido: '', especie: '', marca: '', numeracao: '', informacaoAdd: '',
        codigoBeneficioFiscal: ''
      }
    };
  },
  computed: {
    isNfRemessa() {
      return this.$route.params.typeNf === 'remessa';
    },
    tituloTela() {
      const tipo = this.isNfRemessa ? 'Remessa' : 'Venda';
      if (this.modoDuplicacao) return `Duplicar Nota de ${tipo} Sem JOB`;
      if (this.modoEdicao) return `Editar Nota de ${tipo} Sem JOB`;
      return `Nova Nota de ${tipo} Sem JOB`;
    },
    totalItens() {
      // item.valorTotal vem do dialog reutilizado (CreateItensNotaFiscalView.vue::calcQtd) já na
      // escala de centavos (mesma inconsistência valorUnitario-em-reais / valorTotal-em-centavos
      // existente no dialog compartilhado) — divide por 100 só para exibição aqui.
      return this.itens.reduce((acc, item) => acc + (Number(item.valorTotal) || 0), 0) / 100;
    }
  },
  watch: {
    async buscaDestinatario(value) {
      if (!value || value.length < 2) return;
      const minhaSeq = ++this.buscaDestinatarioSeq;
      this.carregandoDestinatarios = true;
      try {
        const schema = this.isNfRemessa ? 'Fornecedor' : 'Cliente';
        const campo = this.isNfRemessa ? 'nomeFantasia' : 'nomeFantasia';
        const response = await Vue.prototype.$http.get(`/Entity/${schema}/search-fields`, {
          params: { searchFields: campo, value, mode: 'Contains', page: 1, limit: 20 }
        });
        // BUGFIX: descarta a resposta se já existe uma busca mais nova em andamento/concluída,
        // evitando que uma resposta atrasada de um termo digitado antes sobrescreva a lista
        // exibida (ver comentário em buscaDestinatarioSeq, em data()).
        if (minhaSeq !== this.buscaDestinatarioSeq) return;
        this.destinatarios = response.data.data.data;
      } finally {
        if (minhaSeq === this.buscaDestinatarioSeq) this.carregandoDestinatarios = false;
      }
    },
    async buscaStockBalance(value) {
      if (!value || value.length < 2) return;
      // BUGFIX: mesma corrida de requisições identificada em buscaDestinatario (sem debounce, uma
      // chamada por tecla) — sem isso, uma resposta atrasada de uma busca antiga podia sobrescrever
      // a lista de itens exibida com resultados que não correspondem ao texto atualmente digitado.
      const minhaSeq = ++this.buscaStockBalanceSeq;
      this.carregandoStockBalance = true;
      try {
        const response = await Vue.prototype.$http.get('/Entity/StockBalance/search-fields', {
          params: { searchFields: 'itemDescricao', value, mode: 'Contains', page: 1, limit: 20, sortField: 'createAt' }
        });
        if (minhaSeq !== this.buscaStockBalanceSeq) return;
        let resultados = response.data.data.data || [];
        // BUGFIX (mesma lógica do fix já aplicado no fluxo de Job): pode haver mais de um
        // registro de StockBalance para o mesmo itemCodigo (histórico) — usa só o mais recente
        // por item, igual a getUniqueLatest() em TableItensNotaFiscal.vue.
        const maisRecentesPorItem = new Map();
        resultados.forEach((entry) => {
          const dataAtual = entry.updateAt ? new Date(entry.updateAt) : new Date(entry.createAt);
          const existente = maisRecentesPorItem.get(entry.itemCodigo);
          if (!existente) {
            maisRecentesPorItem.set(entry.itemCodigo, entry);
          } else {
            const dataExistente = existente.updateAt ? new Date(existente.updateAt) : new Date(existente.createAt);
            if (dataAtual > dataExistente) maisRecentesPorItem.set(entry.itemCodigo, entry);
          }
        });
        this.stockBalanceOpcoes = Array.from(maisRecentesPorItem.values());
      } finally {
        if (minhaSeq === this.buscaStockBalanceSeq) this.carregandoStockBalance = false;
      }
    }
  },
  methods: {
    itemTextDestinatario(item) {
      if (!item) return '';
      return this.isNfRemessa
        ? (item.codigo ? `${item.codigo} - ${item.nomeFantasia}` : item.nomeFantasia)
        : item.nomeFantasia;
    },

    formatMoeda(valorEmReais) {
      return Number(valorEmReais || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },

    // BUGFIX (achado durante o teste desta tela): a coluna "Valor Unit." da grade de itens
    // exibia "R$ NaN". item.valorUnitario chega cru do dialog reaproveitado
    // (CreateItensNotaFiscalView.vue), formatado pelo campo v-money daquele componente cujo
    // config usa "." tanto para separador de milhar quanto decimal (ex.: digitar 1500 vira a
    // string "1.500.00") — Number("1.500.00") é NaN porque tem dois pontos. valorTotal não sofre
    // disso porque calcQtd() já normaliza para centavos antes de chegar aqui. Convertendo do
    // mesmo jeito (mantém só dígitos, últimos 2 = centavos) só para exibição, sem tocar no
    // componente compartilhado.
    parseValorUnitarioItem(valor) {
      if (valor == null || valor === '') return 0;
      if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0;
      const digits = String(valor).replace(/\D/g, '');
      if (!digits) return 0;
      return Number(digits) / 100;
    },

    selecionarDestinatario(destinatario) {
      if (!destinatario) return;
      this.objNf.cnpj = destinatario.cnpj || '';
      this.objNf.cep = (destinatario.cobrancaCEP || '').replace(/\D/g, '');
      this.objNf.logradouro = destinatario.cobrancaEndereco || '';
      this.objNf.numero = destinatario.cobrancaNumero || '';
      this.objNf.bairro = destinatario.cobrancaBairro || '';
      this.objNf.cidade = destinatario.cobrancaCidadeNome || '';
      this.objNf.uf = NotaFiscalAvulsaPlugNotasService.getSigla(destinatario.cobrancaEstadoNome) || '';
      this.objNf.complemento = destinatario.cobrancaComplemento || '';
    },

    async getCFOPs() {
      const response = await Vue.prototype.$http.get('/Entity/CFOP/search-fields', {
        params: {
          page: 1,
          limit: 9999,
          searchFields: '[codigo]',
          value: this.isNfRemessa ? '[5901,6901,5905,6905,5912,6912,5910,6910,5949]' : undefined
        }
      });
      this.cfops = response.data.data.data;
    },

    selecionarCfop(value) {
      const cfopSelecionado = this.cfops.find((c) => c.codigo == value);
      this.objNf.naturezaOp = cfopSelecionado?.descricao || '';
      this.objNf.operacaoFiscal = cfopSelecionado?.operacaoFiscal || '';
    },

    async getTransportadoras() {
      const response = await Vue.prototype.$http.get('/Entity/Fornecedor', { params: { page: 1, limit: 9999 } });
      this.transportadoras = response.data.data.data;
    },

    abrirBuscaItem() {
      this.stockBalanceSelecionado = null;
      this.stockBalanceOpcoes = [];
      this.buscaStockBalance = '';
      this.dialogBuscaItem = true;
    },

    confirmarItemSelecionado() {
      const sb = this.stockBalanceSelecionado;
      if (!sb) return;

      // Mesma correção já aplicada no fluxo de Job (task #152): para Remessa, o valor unitário
      // vem de valorRealUnitario (por unidade), não de valorReal (total do saldo). Para Venda
      // avulsa, sugere o valorMedioUnitario como ponto de partida (o usuário pode ajustar o
      // preço de venda livremente no próximo passo).
      const valorUnitarioSugerido = this.isNfRemessa
        ? Number(sb.valorRealUnitario || 0)
        : Number(sb.valorMedioUnitario || sb.valorTotalUnitario || 0);

      this.itemEmEdicao = {
        sequencia: this.itens.length + 1,
        descricao: sb.itemDescricao || '',
        codigo: sb.itemCodigo || '',
        itemCodigo: sb.itemCodigo || '',
        quantidade: 1,
        valorUnitario: valorUnitarioSugerido.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        valorTotal: valorUnitarioSugerido.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        unidadeSigla: sb.unidadeSigla || 'PC',
        ncm: '',
        cest: '',
        ctsPis: this.isNfRemessa ? '07 - Operação Isenta da Contribuição' : '01 - Operação Tributável com Alíquota Básica',
        ctsIpi: this.isNfRemessa ? '02 - Entrada Isenta' : '00 - Tributada integralmente',
        ctsIcms: this.isNfRemessa ? '40 - Isenta' : '00 - Tributada integralmente',
        ctsCofins: this.isNfRemessa ? '07 - Operação Isenta da Contribuição' : '01 - Operação Tributável com Alíquota Básica',
        pisPercentual: this.isNfRemessa ? '' : '1,65',
        cofinsPercentual: this.isNfRemessa ? '' : '7,60',
        icmsPercentualBaseCalculo: '',
        icmsBaseCalculo: '',
        pisBaseCalculo: 0,
        cofinsBaseCalculo: 0,
        ipiBaseCalculo: 0,
        ipiPercentual: '',
        valorFrete: 0,
        valorSeguro: 0,
        valorDesconto: 0,
        valorOutros: 0,
        valorBaseCalculoIbsCbs: 0
      };
      this.itemEmEdicaoIndex = -1;
      this.dialogBuscaItem = false;
      this.openItemEdit = true;
    },

    editarItem(index) {
      this.itemEmEdicao = { ...this.itens[index] };
      this.itemEmEdicaoIndex = index;
      this.openItemEdit = true;
    },

    removerItem(index) {
      this.itens.splice(index, 1);
      this.itens.forEach((item, i) => { item.sequencia = i + 1; });
    },

    handleSaveItem(item) {
      if (this.itemEmEdicaoIndex >= 0) {
        this.itens.splice(this.itemEmEdicaoIndex, 1, item);
      } else {
        this.itens.push(item);
      }
      this.openItemEdit = false;
      this.itemEmEdicaoIndex = -1;
    },

    handleCancelItem() {
      this.openItemEdit = false;
      this.itemEmEdicaoIndex = -1;
    },

    toIntegerInput(value) {
      if (value == null || value === '') return 0;
      if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
      return Number(String(value).replace(/\./g, '').replace(/,/g, '')) || 0;
    },

    toStringInput(value) {
      if (value == null) return '';
      return String(value);
    },

    async getAutoIncFisPreDoc() {
      const response = await this.fisPreDocEmi.autoInc('FisPreDocEmi', 'codigo', '######');
      return response.data;
    },

    // Igual a createItensPreNota() em CreateIssuanceInvoiceView.vue — persiste os itens em
    // memória via insertMany e devolve os ids gerados (todos novos, nota avulsa sempre nasce
    // do zero).
    async persistirItens() {
      const itensCriar = this.itens.map((nf) => ({
        sequencia: Number(nf.sequencia),
        descricao: nf.descricao,
        // BUGFIX (achado durante o teste): "itemCodigo" não existe no schema de
        // FisPreDocEmiItem (confirmado via GET /schema/FisPreDocEmiItem) — o backend rejeita com
        // 400 campos fora do schema (mesma lição do task #122). O código do item já vai em
        // "codigo", que é um campo válido do schema.
        codigo: nf.codigo,
        quantidade: String(nf.quantidade),
        unidadeSigla: nf.unidadeSigla,
        ncm: nf.ncm || undefined,
        cest: nf.cest || undefined,
        ctsPis: nf.ctsPis,
        ctsIpi: nf.ctsIpi,
        ctsIcms: nf.ctsIcms,
        ctsCofins: nf.ctsCofins,
        icmsPercentual: this.toStringInput(nf.icmsPercentual),
        icmsPercentualBaseCalculo: this.toStringInput(nf.icmsPercentualBaseCalculo),
        icmsBaseCalculo: this.toIntegerInput(nf.icmsBaseCalculo),
        icmsValor: this.toIntegerInput(nf.icmsValor),
        resultBaseCalcICMS: this.toIntegerInput(nf.resultBaseCalcICMS),
        pisPercentual: this.toStringInput(nf.pisPercentual),
        pisBaseCalculo: this.toIntegerInput(nf.pisBaseCalculo),
        pisValor: this.toIntegerInput(nf.pisValor),
        cofinsPercentual: this.toStringInput(nf.cofinsPercentual),
        cofinsBaseCalculo: this.toIntegerInput(nf.cofinsBaseCalculo),
        cofinsValor: this.toIntegerInput(nf.cofinsValor),
        ipiPercentual: this.toStringInput(nf.ipiPercentual),
        ipiBaseCalculo: this.toIntegerInput(nf.ipiBaseCalculo),
        ipiValor: this.toIntegerInput(nf.ipiValor),
        // BUGFIX (achado durante o teste desta tela, corrigido novamente): a tentativa anterior
        // aqui fazia Math.round((Number(nf.valorUnitario) || 0) * 100), assumindo que
        // nf.valorUnitario já era um número limpo em REAIS. Na prática o campo é alimentado pelo
        // v-money do dialog reutilizado (CreateItensNotaFiscalView.vue), cujo config usa "." tanto
        // para separador de milhar quanto decimal — ex.: digitar 1500 vira a STRING "1.500.00".
        // Number("1.500.00") é NaN (dois pontos), então Math.round(NaN * 100) sempre persistia
        // valorUnitario = 0, mesmo com valorTotal correto. toIntegerInput já trata exatamente esse
        // formato (remove '.' e ',' e usa os 2 últimos dígitos como centavos), igual é usado logo
        // abaixo para valorTotal — reaproveitando aqui em vez de reinventar o parse.
        valorUnitario: this.toIntegerInput(nf.valorUnitario),
        valorTotal: this.toIntegerInput(nf.valorTotal),
        valorFrete: this.toIntegerInput(nf.valorFrete),
        valorSeguro: this.toIntegerInput(nf.valorSeguro),
        valorDesconto: this.toIntegerInput(nf.valorDesconto),
        valorOutros: this.toIntegerInput(nf.valorOutros),
        aliquotaUf: nf.aliquotaUf != null ? this.toStringInput(nf.aliquotaUf) : '',
        valorUf: this.toIntegerInput(nf.valorUf),
        cstIbsCbs: nf.cstIbsCbs || undefined,
        classificacaoIbsCbs: nf.classificacaoIbsCbs || undefined,
        percentualBaseCalculoIbsCbs: nf.percentualBaseCalculoIbsCbs,
        valorBaseCalculoIbsCbs: this.toIntegerInput(nf.valorBaseCalculoIbsCbs),
        aliquotaCbs: this.toStringInput(nf.aliquotaCbs),
        valorCbs: this.toIntegerInput(nf.valorCbs)
      }));

      if (itensCriar.length === 0) return [];

      const response = await Vue.prototype.$http.post('/Entity/insertMany/FisPreDocEmiItem', itensCriar);
      return response.data.data.map((item) => item.id);
    },

    // MELHORIA: fetch-merge-PUT usado para EDITAR uma nota já existente sem apagar campos que
    // esta tela não conhece/não reenvia — mesmo padrão já usado em IssuanceInvoiceView.vue
    // (mergeEntityPayload), necessário porque o PUT de /Entity/<schema> substitui o documento
    // pelo payload enviado (não faz merge no servidor).
    async mergeEntityPayload(schemaName, id, updates = {}) {
      const response = await Vue.prototype.$http.get(`/Entity/${schemaName}/${id}`);
      const entity = response?.data?.data || {};

      return {
        ...entity,
        ...updates,
        id: entity?.id || entity?._id || id,
        _id: undefined
      };
    },

    async salvarNota() {
      if (!this.destinatarioSelecionado) {
        this.$notfy.error('Selecione o destinatário da nota.');
        return;
      }
      if (this.itens.length === 0) {
        this.$notfy.error('Adicione ao menos um item à nota.');
        return;
      }
      if (!this.objNf.cfop) {
        this.$notfy.error('Selecione o CFOP da nota.');
        return;
      }

      // MELHORIA: "edição real" (não duplicação) atualiza os registros já existentes (mesmo
      // FisPreDocEmi/EmissaoNotasFiscais) em vez de criar novos — id vem de notaSalva, carregado
      // por carregarNotaExistente() no created() a partir de ?id=/&emissaoId= na rota (ver
      // IssuanceInvoiceView.vue::editValue). Duplicar (modoDuplicacao) sempre cria registros novos.
      const isEdicaoReal = this.modoEdicao && !this.modoDuplicacao && !!this.notaSalva?.fisPreDocEmiId;

      this.salvando = true;
      try {
        // NOTA: os itens antigos (FisPreDocEmiItem) da nota original NÃO são reaproveitados/
        // atualizados em edição — são sempre recriados do zero a partir do estado atual de
        // "this.itens" (mesma função usada na criação) e o array "itens" da FisPreDocEmi passa a
        // apontar só para os novos ids. Os documentos antigos ficam órfãos no banco (não são
        // excluídos). Simplificação deliberada dado que a edição só é permitida enquanto a nota
        // está "Pendente" (nunca emitida) — ver decisão registrada no relatório desta tarefa.
        const itensIds = await this.persistirItens();

        const dataEmissao = new Date().toISOString().split('T')[0] + 'T03:00:00Z';

        const camposFisPreDocEmi = {
          // Sem "job" propositalmente — é isso que caracteriza a nota como avulsa (usado pelo
          // filtro da listagem de notas avulsas). Não inventamos nenhum campo novo no schema
          // (o backend rejeita com 400 campos fora do schema — lição já aprendida no fluxo de
          // Job/NCM), só deixamos de preencher um campo já existente e opcional.
          cliente: !this.isNfRemessa ? this.destinatarioSelecionado.id : undefined,
          cnpj: this.objNf.cnpj,
          statusEmissao: 'DESENVOLVENDO',
          dataEmissao,
          naturezaOperacao: this.objNf.naturezaOp,
          condicaoPagamento: this.objNf.condPag,
          destinatarioCep: this.objNf.cep,
          destinatarioCidade: this.objNf.cidade,
          destinatarioLogradouro: this.objNf.logradouro,
          destinatarioNumero: this.objNf.numero,
          destinatarioBairro: this.objNf.bairro,
          codigoCidade: this.objNf.codigoCidade,
          uf: this.objNf.uf,
          email: this.objNf.email,
          itens: itensIds,
          parcelas: [],
          dataSaida: dataEmissao,
          transportadora: this.objNf.transportadora || undefined,
          pesoBruto: this.objNf.pesoBruto || undefined,
          pesoLiquido: this.objNf.pesoLiquido || undefined,
          cfop: this.objNf.cfop,
          fisOper: this.objNf.operacaoFiscal || undefined,
          informacaoAdd: this.objNf.informacaoAdd,
          meioPagamento: this.objNf.meioPagamento,
          codigoBeneficioFiscal: this.isNfRemessa ? (this.objNf.codigoBeneficioFiscal || undefined) : undefined
        };

        const payloadFisPreDocEmi = isEdicaoReal
          ? await this.mergeEntityPayload('FisPreDocEmi', this.notaSalva.fisPreDocEmiId, camposFisPreDocEmi)
          : { codigo: await this.getAutoIncFisPreDoc(), ...camposFisPreDocEmi };

        const responseFisPreDocEmi = await this.fisPreDocEmi.insertOrUpdate(payloadFisPreDocEmi);

        if (!responseFisPreDocEmi?.data?.data?.id) {
          this.$notfy.error('Erro ao salvar a nota fiscal Sem JOB. Verifique os dados e tente novamente.');
          return;
        }

        const fisPreDocEmiId = responseFisPreDocEmi.data.data.id;

        const camposEmissao = {
          // BUGFIX (achado ao revisar por que a nota de teste não aparecia na listagem): o campo
          // "tipoNotaFiscal" do schema EmissaoNotasFiscais é um enum fechado com os valores
          // "Nota Fiscal" / "Nota Fiscal de Remessa" (com espaço — confirmado via GET
          // /schema/EmissaoNotasFiscais e nos registros reais já existentes). Estávamos enviando
          // "Nota_Fiscal"/"Nota_Fiscal_de_Remessa" (com underscore), um valor fora do enum. Como o
          // apiClient resolve em vez de rejeitar em erro (ver CLAUDE.md), o insertOrUpdate falhava
          // silenciosamente (400) e a tela seguia mostrando "sucesso" sem o registro ter sido
          // criado — por isso a nota de teste nunca apareceu na listagem (NotaAvulsaListView.vue
          // depende justamente deste registro para localizar a FisPreDocEmi correspondente).
          tipoNotaFiscal: this.isNfRemessa ? 'Nota Fiscal de Remessa' : 'Nota Fiscal',
          notaFiscalDeRemessa: this.isNfRemessa,
          destinatario: !this.isNfRemessa ? this.destinatarioSelecionado.id : undefined,
          destinatarioFornecedor: this.isNfRemessa ? this.destinatarioSelecionado.id : undefined,
          destinatarioNome: !this.isNfRemessa ? this.destinatarioSelecionado.nomeFantasia : undefined,
          destinatarioFornecedorNome: this.isNfRemessa ? this.destinatarioSelecionado.nomeFantasia : undefined,
          // BUGFIX: o restante da tela de Emissão de Nota (IssuanceInvoiceView.vue) usa
          // "Processando" para significar "emissão em andamento no PlugNotas" — isStatusBloqueadoEdicao()
          // já bloqueia Editar/Excluir para esse status. Esta tela gravava "Processando" logo na
          // criação (quando na verdade a nota ainda nem foi emitida, só salva como rascunho), o
          // que passou a ser um problema real agora que "Editar"/"Excluir Nota Fiscal" desta nota
          // passam a rodar pelo mesmo menu/regras da grade unificada (IssuanceInvoiceView.vue) —
          // a nota nasceria já bloqueada para edição. Alinhado ao mesmo valor inicial usado por
          // CreateIssuanceInvoiceView.vue para notas com Job: "Pendente" (editável/excluível até
          // ser efetivamente emitida por emitirNotaFiscalAvulsa(), que aí sim grava "Processando").
          // Em edição real, preserva o status atual (fetch-merge já traz o statusNf existente;
          // só sobrescreve se ainda não houver um, ex.: registro de emissão nunca criado).
          statusNf: isEdicaoReal ? undefined : 'Pendente',
          notaFiscal: fisPreDocEmiId,
          // BUGFIX: ao contrário do fluxo com Job (CreateIssuanceInvoiceView.vue), este payload
          // nunca enviava "valueNf" (campo usado pela listagem/relatórios para exibir o valor da
          // nota). O EmissaoNotasFiscais era salvo sem valor algum, então toda Nota de Venda/
          // Remessa Sem JOB aparecia com valor zerado mesmo com itens e valores corretos
          // preenchidos na tela. "totalItens" já soma item.valorTotal (centavos) / 100, mesma
          // conversão usada em emitNotaFiscal.valorNf / 100 no fluxo com Job.
          valueNf: this.totalItens
        };

        const payloadEmissao = (isEdicaoReal && this.notaSalva.emissaoDocId)
          ? await this.mergeEntityPayload('EmissaoNotasFiscais', this.notaSalva.emissaoDocId, camposEmissao)
          : camposEmissao;

        // Garante um valor mesmo quando o merge não achou statusNf nenhum (registro incompleto).
        if (!payloadEmissao.statusNf) payloadEmissao.statusNf = 'Pendente';

        const responseEmissao = await this.emissaoDoc.insertOrUpdate(payloadEmissao);

        if (!responseEmissao?.data?.data?.id) {
          // BUGFIX: antes disso não havia nenhuma verificação aqui — uma falha neste insert
          // (schema, permissão, etc.) passava despercebida e a nota ficava "órfã" (FisPreDocEmi
          // salva, mas sem o registro de EmissaoNotasFiscais que a listagem usa para encontrá-la).
          this.$notfy.error('A nota fiscal foi salva, mas houve um erro ao registrar o vínculo de emissão. Avise o suporte antes de continuar.');
          this.notaSalva = { fisPreDocEmiId, emissaoDocId: undefined };
          return;
        }

        this.notaSalva = {
          fisPreDocEmiId,
          emissaoDocId: responseEmissao.data.data.id
        };
        this.modoEdicao = true;
        this.modoDuplicacao = false;

        this.$notfy.success('Nota Sem JOB salva com sucesso. Você já pode rodar a Pré-Visualização.');
      } finally {
        this.salvando = false;
      }
    },

    // MELHORIA: carrega uma nota Sem JOB já existente para edição/duplicação, navegada a partir
    // de IssuanceInvoiceView.vue::editValue/duplicateValue (?id=<FisPreDocEmi>&emissaoId=
    // <EmissaoNotasFiscais>[&duplicate=1]). Reconstrói destinatário/dados fiscais/itens a partir
    // dos registros já persistidos (inverso de persistirItens()/salvarNota()).
    async carregarNotaExistente() {
      const fisPreDocEmiId = this.$route.query.id;
      if (!fisPreDocEmiId) return;

      this.carregandoNotaExistente = true;
      try {
        const responseFisPreDocEmi = await Vue.prototype.$http.get(`/Entity/FisPreDocEmi/${fisPreDocEmiId}`);
        const fisPreDocEmi = responseFisPreDocEmi?.data?.data;

        if (!fisPreDocEmi) {
          this.$notfy.error('Não foi possível carregar a nota fiscal Sem JOB para edição.');
          return;
        }

        const destinatarioId = this.isNfRemessa
          ? (fisPreDocEmi.fornecedor || fisPreDocEmi.destinatarioFornecedor)
          : fisPreDocEmi.cliente;

        if (destinatarioId) {
          const schema = this.isNfRemessa ? 'Fornecedor' : 'Cliente';
          const idDestinatario = this.getRelationEntityId(destinatarioId);
          const responseDestinatario = await Vue.prototype.$http.get(`/Entity/${schema}/${idDestinatario}`);
          const destinatario = responseDestinatario?.data?.data;

          if (destinatario) {
            this.destinatarios = [destinatario];
            this.destinatarioSelecionado = destinatario;
          }
        }

        this.objNf = {
          ...this.objNf,
          cnpj: fisPreDocEmi.cnpj || '',
          email: fisPreDocEmi.email || '',
          cep: fisPreDocEmi.destinatarioCep || '',
          cidade: fisPreDocEmi.destinatarioCidade || '',
          codigoCidade: fisPreDocEmi.codigoCidade || '',
          logradouro: fisPreDocEmi.destinatarioLogradouro || '',
          bairro: fisPreDocEmi.destinatarioBairro || '',
          numero: fisPreDocEmi.destinatarioNumero || '',
          uf: fisPreDocEmi.uf || '',
          condPag: fisPreDocEmi.condicaoPagamento || 'á vista',
          meioPagamento: fisPreDocEmi.meioPagamento || '',
          cfop: fisPreDocEmi.cfop || null,
          naturezaOp: fisPreDocEmi.naturezaOperacao || '',
          operacaoFiscal: fisPreDocEmi.fisOper || '',
          transportadora: this.getRelationEntityId(fisPreDocEmi.transportadora) || '',
          pesoBruto: fisPreDocEmi.pesoBruto || '',
          pesoLiquido: fisPreDocEmi.pesoLiquido || '',
          informacaoAdd: fisPreDocEmi.informacaoAdd || '',
          codigoBeneficioFiscal: fisPreDocEmi.codigoBeneficioFiscal || ''
        };

        const idsItens = fisPreDocEmi.itens || [];
        if (idsItens.length > 0) {
          const responseItens = await Vue.prototype.$http.get('/Entity/FisPreDocEmiItem/search-fields', {
            params: { ids: idsItens.join(','), sortField: 'sequencia', limit: idsItens.length }
          });
          const itensPersistidos = responseItens?.data?.data?.data || [];

          // Inverte a conversão reais->centavos feita em persistirItens() só para
          // "valorUnitario" (os demais campos monetários/percentuais já são reaproveitados na
          // mesma representação usada pelo dialog CreateItensNotaFiscalView.vue).
          this.itens = itensPersistidos
            .slice()
            .sort((a, b) => (Number(a.sequencia) || 0) - (Number(b.sequencia) || 0))
            .map((item) => ({
              ...item,
              itemCodigo: item.codigo,
              valorUnitario: (Number(item.valorUnitario || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }));
        }

        if (!this.modoDuplicacao) {
          this.notaSalva = {
            fisPreDocEmiId,
            emissaoDocId: this.$route.query.emissaoId || undefined
          };
        }
      } finally {
        this.carregandoNotaExistente = false;
      }
    },

    getRelationEntityId(value) {
      if (Array.isArray(value)) return this.getRelationEntityId(value[0]);
      if (value && typeof value === 'object') return value?._id || value?.id || '';
      return value || '';
    },

    async preVisualizar() {
      if (!this.notaSalva) return;

      this.carregandoPreview = true;
      try {
        const responseFisPreDocEmi = await Vue.prototype.$http.get(`/Entity/FisPreDocEmi/${this.notaSalva.fisPreDocEmiId}`);
        const fisPreDocEmi = responseFisPreDocEmi.data.data;

        const contexto = {
          notaFiscalDeRemessa: this.isNfRemessa,
          tipoNotaFiscal: this.isNfRemessa ? 'Nota_Fiscal_de_Remessa' : 'Nota_Fiscal',
          destinatarioNome: !this.isNfRemessa ? this.destinatarioSelecionado.nomeFantasia : undefined,
          destinatarioFornecedorNome: this.isNfRemessa ? this.destinatarioSelecionado.nomeFantasia : undefined,
          destinatarioInfo: !this.isNfRemessa ? [this.destinatarioSelecionado] : [],
          destinatarioInfoFornecedor: this.isNfRemessa ? [this.destinatarioSelecionado] : [],
          email: this.objNf.email
        };

        const resultado = await NotaFiscalAvulsaPlugNotasService.previewNf(fisPreDocEmi, contexto, (tentativa, max) => {
          this.$notfy.warning(`Prévia ainda processando, tentando novamente... (${tentativa}/${max})`);
        });

        if (resultado.erro) {
          this.$notfy.error(`${resultado.tituloErro}: ${(resultado.mensagens || []).join('; ') || 'sem detalhes'}`);
          console.error('Erro na pré-visualização (nota avulsa):', resultado);
          return;
        }

        this.pdfPreviewBase64 = resultado.pdfBase64;
        this.dialogPreview = true;
      } finally {
        this.carregandoPreview = false;
      }
    }
  },
  async created() {
    // MELHORIA: detecta modo edição/duplicação a partir da query string (mesma convenção já
    // usada por CreateIssuanceInvoiceView.vue: ?id=...&duplicate=1), navegada por
    // IssuanceInvoiceView.vue::editValue/duplicateValue quando a nota é Sem JOB (isAvulsa).
    const idExistente = this.$route.query.id;
    const duplicando = ['1', 'true', 'True'].includes(String(this.$route.query.duplicate || ''));
    this.modoDuplicacao = !!idExistente && duplicando;
    this.modoEdicao = !!idExistente && !duplicando;

    await Promise.all([this.getCFOPs(), this.getTransportadoras()]);

    if (idExistente) {
      await this.carregarNotaExistente();
    }
  }
};
</script>
